import React, { useEffect, useRef, useState } from "react";

import aboutTeam from "../assets/Asset-about.webp";
import whoWeServeBg from "../assets/what we ser/who-we-serve-bg.png";
import whoWeServeArrow from "../assets/arrow.svg";
// import skerchsBg from "../assets/skerchs.webp"; // brush stroke removed for Who We Serve design
import shapes from "../img/Shapes.svg";
// import vectorImage from "../assets/Vector.webp"; // used by Why Partner With ASSET
import wesince from "../assets/wesince.svg";
// import divideWaveUrl from "../assets/Divider.svg"; // replaced by yellow arc divider
// import { Link } from "react-router-dom"; // used by Why Partner With ASSET
import herodivider from "../assets/heroDivider.webp";
import heroimage from "../assets/image hero.webp";
import {
  JOIN_US_EMAIL_REGEX,
  JOIN_US_SUCCESS_AUTO_HIDE_MS_HERO,
  JOIN_US_SUCCESS_MESSAGE,
  submitJoinUsEmail,
} from "../lib/joinUs";
import { useCmsPage } from "../hooks/useCmsPage";
import homeFallbackContent from "../lib/fallbackContent/home";
import CmsPageLoader from "./CmsPageLoader";
import ProgramsOverview from "./ProgramsOverview";
import IndustryPartnerships from "./IndustryPartnerships";
import JoinMovement from "./JoinMovement";
import ImpactAreas from "./ImpactAreas";
import { mergeCmsSection } from "../lib/mergeCmsSection";
import { resolveCmsImage } from "../lib/cmsAssets";
import { apiBaseUrl } from "../lib/cmsApi";

// College logos
import logoB from "../assets/College_logos/bangalore institue .webp";
import logoBms from "../assets/College_logos/bms college.webp";
import logoBnm from "../assets/College_logos/bnm college.webp";
import logoCambridge from "../assets/College_logos/cambridge institue.webp";
import logoCiet from "../assets/College_logos/ciet logo.webp";
import logoDayanand from "../assets/College_logos/dayanand sagar college.webp";
import logoGm from "../assets/College_logos/gm college.webp";
import logoKns from "../assets/College_logos/kns college.webp";
import logoPresidency from "../assets/College_logos/presidency college.webp";
import logoRanganathar from "../assets/College_logos/ranganathar college polytechnic .webp";
import logoRvs from "../assets/College_logos/rvs college.webp";
import logoSea from "../assets/College_logos/sea college of institue.webp";
import logoSirM from "../assets/College_logos/sir_m_visvesvaraya_institute_of_technology_logo.webp";
import logoSriShaki from "../assets/College_logos/sri shaki college.webp";
import logoSrm from "../assets/College_logos/srm university.webp";
import logoTagore from "../assets/College_logos/tagore college.webp";
import vector1 from "../assets/College_logos/Vector1.svg";
import vector2 from "../assets/College_logos/Vector2.svg";
import vector3 from "../assets/College_logos/Vector3.svg";
import vector4 from "../assets/College_logos/Vector4.svg";

const row1Logos = [
  { src: logoCambridge, alt: "Cambridge Institute of Technology", width: 350, height: 103, className: "h-12 sm:h-14 lg:h-16 max-w-[160px] sm:max-w-[200px]" },
  { src: logoBms, alt: "BMS Institute of Technology and Management", width: 180, height: 180, className: "h-28 sm:h-30 lg:h-32 max-w-[150px] sm:max-w-[210px]" },
  { src: logoDayanand, alt: "Dayananda Sagar College of Engineering", width: 350, height: 116, className: "h-16 sm:h-18 lg:h-20 max-w-[150px] sm:max-w-[170px]" },
  { src: logoCiet, alt: "CIET College", width: 180, height: 180, className: "h-14 sm:h-16 lg:h-18 max-w-[90px] sm:max-w-[110px]" },
  { src: logoKns, alt: "KNS Institute of Technology", width: 350, height: 175, className: "h-16 sm:h-18 lg:h-20 max-w-[110px] sm:max-w-[130px]" },
  { src: logoB, alt: "Bangalore Institute of Technology", width: 350, height: 81, className: "h-12 sm:h-14 lg:h-16 max-w-[160px] sm:max-w-[200px]" },
  { src: logoGm, alt: "GM Institute of Technology", width: 180, height: 180, className: "h-14 sm:h-16 lg:h-18 max-w-[90px] sm:max-w-[110px]" },
  { src: logoBnm, alt: "BNM Institute of Technology", width: 350, height: 70, className: "h-20 sm:h-22 lg:h-24 max-w-[200px] sm:max-w-[230px]" },
];

const row2Logos = [
  { src: logoSrm, alt: "SRM Institute of Science and Technology", width: 350, height: 118, className: "h-8 sm:h-10 lg:h-12 max-w-[130px] sm:max-w-[160px]" },
  { src: logoPresidency, alt: "Presidency University", width: 180, height: 144, className: "h-24 sm:h-26 lg:h-28 max-w-[180px] sm:max-w-[220px]" },
  { src: logoRanganathar, alt: "Sri Ranganathar Institute of Polytechnic College", width: 350, height: 102, className: "h-16 sm:h-18 lg:h-20 max-w-[180px] sm:max-w-[220px]" },
  { src: logoB, alt: "Bangalore Institute of Technology", width: 350, height: 81, className: "h-12 sm:h-14 lg:h-16 max-w-[160px] sm:max-w-[200px]" },
  { src: logoSea, alt: "S.E.A Group of Institutions", width: 284, height: 89, className: "h-12 sm:h-14 lg:h-16 max-w-[140px] sm:max-w-[170px]" },
  { src: logoRvs, alt: "RVS College", width: 180, height: 194, className: "h-14 sm:h-16 lg:h-18 max-w-[80px] sm:max-w-[100px]" },
  { src: logoSirM, alt: "Sir M Visvesvaraya Institute of Technology", width: 180, height: 180, className: "h-14 sm:h-16 lg:h-18 max-w-[80px] sm:max-w-[100px]" },
  { src: logoSriShaki, alt: "Sri Shakthi Institute of Engineering and Technology", width: 350, height: 64, className: "h-16 sm:h-18 lg:h-20 max-w-[130px] sm:max-w-[150px]" },
  { src: logoTagore, alt: "Tagore Institute of Engineering and Technology", width: 180, height: 172, className: "h-12 sm:h-14 lg:h-16 max-w-[80px] sm:max-w-[100px]" },
];

/** Renders CMS headline text with line breaks from `\n`. */
function renderHeadline(text) {
  if (!text) return null;
  const lines = text.split("\n");
  return lines.map((line, index) => (
    <React.Fragment key={`${line}-${index}`}>
      {line}
      {index < lines.length - 1 ? (
        <br className="hidden md:block lg:block" />
      ) : null}
    </React.Fragment>
  ));
}


function Hero() {
  // CMS: try API first; fallback only after fetch completes (see useCmsPage).
  const { status: cmsStatus, sections: cmsSections } = useCmsPage(
    "home",
    homeFallbackContent
  );

  const hero = mergeCmsSection(cmsSections?.hero, homeFallbackContent.hero);
  const homepageStats = cmsSections?.homepage_stats?.items || [];
  const aboutPreview = mergeCmsSection(
    cmsSections?.about_preview,
    homeFallbackContent.about_preview,
  );
  const partnerLogos = cmsSections?.partner_logos;
  const activeRow1Logos = (partnerLogos?.row1 || []).length > 0
    ? partnerLogos.row1.map((item, idx) => ({
        src: resolveCmsImage(item.logoKey, apiBaseUrl) || row1Logos[idx]?.src || "",
        alt: item.alt || row1Logos[idx]?.alt || "Partner college",
        className: row1Logos[idx]?.className || "h-14 sm:h-16 max-w-[160px] sm:max-w-[200px]",
        width: row1Logos[idx]?.width,
        height: row1Logos[idx]?.height,
      }))
    : row1Logos;

  const activeRow2Logos = (partnerLogos?.row2 || []).length > 0
    ? partnerLogos.row2.map((item, idx) => ({
        src: resolveCmsImage(item.logoKey, apiBaseUrl) || row2Logos[idx]?.src || "",
        alt: item.alt || row2Logos[idx]?.alt || "Partner college",
        className: row2Logos[idx]?.className || "h-14 sm:h-16 max-w-[160px] sm:max-w-[200px]",
        width: row2Logos[idx]?.width,
        height: row2Logos[idx]?.height,
      }))
    : row2Logos;

  const aboutSeal =
    resolveCmsImage(aboutPreview?.sealImageKey, apiBaseUrl) || wesince;

  const impactAreas = cmsSections?.impact_areas;
  // Why Partner With ASSET (section commented out below)
  // const partnership = cmsSections?.partnership;
  // const partnerCards = partnership?.cards || [];
  const whoWeServe = mergeCmsSection(
    cmsSections?.who_we_serve,
    homeFallbackContent.who_we_serve,
  );
  const whoWeServeSlides = whoWeServe.slides || [];
  const programsOverview = cmsSections?.programs_overview;
  const industryPartnerships = cmsSections?.industry_partnerships;
  const joinMovement = cmsSections?.join_movement;
  const joinUs = mergeCmsSection(cmsSections?.join_us, homeFallbackContent.join_us);

  const whoWeServeScrollRef = useRef(null);
  const [joinEmail, setJoinEmail] = useState("");
  const [joinSubmitting, setJoinSubmitting] = useState(false);
  const [joinMessage, setJoinMessage] = useState("");
  const [joinError, setJoinError] = useState("");
  const joinSuccessTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (joinSuccessTimeoutRef.current) {
        clearTimeout(joinSuccessTimeoutRef.current);
      }
    };
  }, []);

  function scheduleJoinSuccessHide() {
    if (joinSuccessTimeoutRef.current) {
      clearTimeout(joinSuccessTimeoutRef.current);
    }
    joinSuccessTimeoutRef.current = setTimeout(() => {
      setJoinMessage("");
      joinSuccessTimeoutRef.current = null;
    }, JOIN_US_SUCCESS_AUTO_HIDE_MS_HERO);
  }

  async function handleJoinUsSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const trimmed = joinEmail.trim();
    setJoinMessage("");
    setJoinError("");

    if (!JOIN_US_EMAIL_REGEX.test(trimmed)) {
      setJoinError("Please enter a valid email address (e.g. name@example.com).");
      return;
    }

    setJoinSubmitting(true);
    try {
      await submitJoinUsEmail(trimmed);
      setJoinMessage(JOIN_US_SUCCESS_MESSAGE);
      scheduleJoinSuccessHide();
      setJoinEmail("");
      form.reset();
    } catch (err) {
      setJoinError(err.message || "Something went wrong. Please try again.");
    } finally {
      setJoinSubmitting(false);
    }
  }

  const scrollWhoWeServe = (direction) => {
    const el = whoWeServeScrollRef.current;
    if (!el) return;
    const cards = [...el.querySelectorAll("[data-serve-card]")];
    if (cards.length === 0) return;

    const cRect = el.getBoundingClientRect();
    const maxScroll = Math.max(0, el.scrollWidth - el.clientWidth);

    const alignCardStart = (index) => {
      const card = cards[index];
      const kRect = card.getBoundingClientRect();
      return el.scrollLeft + (kRect.left - cRect.left);
    };

    // Largest snap index whose start is at or before current scroll (stable at maxScroll)
    let page = 0;
    for (let i = 0; i < cards.length; i++) {
      if (alignCardStart(i) <= el.scrollLeft + 8) page = i;
    }

    const target =
      direction > 0
        ? Math.min(cards.length - 1, page + 1)
        : Math.max(0, page - 1);

    const nextLeft = Math.min(
      Math.max(0, alignCardStart(target)),
      maxScroll,
    );
    el.scrollTo({ left: nextLeft, behavior: "smooth" });
  };

  // CMS: wait for API attempt before rendering (prevents fallback→API flicker).
  if (cmsStatus === "loading") {
    return <CmsPageLoader label="Loading page content…" />;
  }

  const heroImage = hero?.image || heroimage;

  return (
    <>
      <section className="relative overflow-hidden bg-[#FAF8F3]">
        <div className="relative flex flex-col lg:flex-row min-h-0 items-start sm:min-h-[500px] lg:items-center">

          {/* 🔹 LEFT CONTENT */}
          <div
            className="relative z-10 w-full lg:w-[55%]
  px-4 sm:px-6 md:px-8 lg:ml-15
  py-4 sm:py-10 md:py-14 lg:py-20"
          >
            <h1
              className="font-bold text-[#1a202c]
    text-lg sm:text-xl md:text-2xl lg:text-[2.5rem]
    leading-[1.4] sm:leading-[1.35] md:leading-[1.3] lg:leading-[1.2]
    max-w-full sm:max-w-[32rem] md:max-w-[36rem] lg:max-w-[44rem]"
            >
              {renderHeadline(hero?.headline)}
            </h1>

            <p
              className="mt-3 sm:mt-4 md:mt-5 text-[#4a5568]
    text-[15px] sm:text-[16px] md:text-[18px] lg:text-[20px]
    leading-relaxed
    max-w-full sm:max-w-xl md:max-w-xl lg:max-w-2xl"
            >
              {hero?.subtitle}
            </p>

            <div className="mt-5 flex w-full flex-col gap-3 sm:mt-6 sm:w-auto sm:flex-row sm:flex-wrap sm:items-center">
              <a
                href={hero?.ctaLink || "/contact-us"}
                className="inline-flex items-center justify-center
    w-full sm:w-auto
    rounded-lg bg-[#1565D8]
    px-5 py-2.5
    text-[14px] md:text-[16px] font-medium text-white
    transition"
              >
                {hero?.ctaText || "Partner With ASSET"}
                <span className="ml-1.5" aria-hidden>
                  →
                </span>
              </a>
              {hero?.secondaryCtaText ? (
                <a
                  href={hero.secondaryCtaLink || "#join-movement"}
                  className="inline-flex items-center justify-center
    w-full sm:w-auto
    rounded-lg bg-black
    px-5 py-2.5
    text-[14px] md:text-[16px] font-medium text-white
    transition"
                >
                  {hero.secondaryCtaText}
                </a>
              ) : null}
            </div>
          </div>

          {/* 🔹 RIGHT IMAGE WITH ANGLE */}
          <div className="relative px-4 sm:px-6 md:px-8 lg:px-0 lg:absolute lg:right-0 lg:top-[-15%] h-[250px] sm:h-[400px] w-full lg:h-[115%] lg:w-[50%]">
            <div className="h-full w-full relative block">

              {/* Image */}
              <img
                src={heroImage}
                alt="Engineering"
                fetchpriority="high"
                loading="eager"
                className="absolute inset-0 h-full w-full object-contain lg:object-cover"
              />
            </div>
          </div>

        </div>

        {/* 🔻 Divider */}
        <img
          src={herodivider}
          alt=""
          width="1600"
          height="99"
          className="w-full h-auto block relative z-10 lg:mt-[-73px]"
        />
      </section>

      {/* ── College Logo Marquee ── */}
      <div className="bg-white py-5 sm:py-8 overflow-hidden">
        <style>{`
          @keyframes marquee-ltr {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          @keyframes marquee-rtl {
            0%   { transform: translateX(-50%); }
            100% { transform: translateX(0); }
          }
          .marquee-ltr { animation: marquee-ltr 40s linear infinite; }
          .marquee-rtl { animation: marquee-rtl 40s linear infinite; }

          /* Pause the inner strip when hovering the row wrapper */
          .marquee-row:hover .marquee-ltr,
          .marquee-row:hover .marquee-rtl {
            animation-play-state: paused;
          }

          /* Individual logo hover lift */
          .marquee-row img:hover {
            transform: scale(1.08);
          }
        `}</style>

        {/* Row 1 — right → left */}
        <div className="marquee-row relative flex overflow-hidden cursor-pointer min-h-[112px] sm:min-h-[120px] lg:min-h-[128px]">
          <div className="flex items-center gap-8 sm:gap-12 lg:gap-16 marquee-rtl whitespace-nowrap">
            {[...activeRow1Logos, ...activeRow1Logos].map((logo, i) => (
              <img
                key={`row1-${i}`}
                src={logo.src}
                alt={logo.alt}
                width={logo.width}
                height={logo.height}
                loading="lazy"
                className={`${logo.className} w-auto object-contain flex-shrink-0`}
              />
            ))}
          </div>
        </div>

        {/* Row 2 — left → right */}
        <div className="marquee-row relative flex overflow-hidden cursor-pointer min-h-[96px] sm:min-h-[104px] lg:min-h-[112px]">
          <div className="flex items-center gap-8 sm:gap-12 lg:gap-16 marquee-ltr whitespace-nowrap">
            {[...activeRow2Logos, ...activeRow2Logos].map((logo, i) => (
              <img
                key={`row2-${i}`}
                src={logo.src}
                alt={logo.alt}
                width={logo.width}
                height={logo.height}
                loading="lazy"
                className={`${logo.className} w-auto object-contain flex-shrink-0`}
              />
            ))}
          </div>
        </div>
      </div>

      <section className="bg-[#FAF8F3] px-4 py-10 sm:px-6 sm:py-12 lg:px-14">
        <div className="mx-auto max-w-7xl">
          <div className="grid grid-cols-2 gap-6 text-center md:grid-cols-4 md:gap-8">
            {homepageStats.map(({ stat, description }) => (
              <div
                key={stat + description}
                className="flex flex-col items-center gap-3 px-2"
              >
                <span
                  className="text-[24px] font-bold leading-none text-[#2B2B2B] md:text-[35px] lg:text-[45px]"
                  style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
                >
                  {stat}
                </span>
                <p
                  className="max-w-[280px] text-[16px] leading-relaxed text-[#4a5568]"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="overflow-visible bg-white">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 overflow-visible px-4 py-12 sm:gap-10 sm:px-6 sm:py-16 md:py-20 lg:grid-cols-2 lg:items-start lg:gap-12 lg:px-10">
          <div className="relative overflow-visible pt-2 sm:pt-6 lg:pr-8 xl:pr-14">
            <img
              src={aboutPreview?.image || aboutTeam}
              alt="Team collaborating on engineering plans and laptops"
              loading="lazy"
              className="h-[min(70vw,340px)] w-full rounded-[28px] object-cover shadow-sm sm:h-[min(55vw,420px)] md:h-[460px] lg:h-[500px]"
            />
            {/* Round seal — top-left on photo (design) */}
            <div className="absolute left-3 top-3 z-20 flex h-20 w-20 items-center justify-center rounded-full bg-[#FAF8F3] shadow-md sm:left-0 sm:top-0 sm:h-[100px] sm:w-[100px] sm:-translate-x-2 sm:-translate-y-2 lg:-translate-x-4 lg:-translate-y-3">
              <img
                src={aboutSeal}
                alt="We are growing since 2022"
                loading="lazy"
                className="h-[92%] w-[92%] object-contain"
              />
            </div>
            <div
              className="absolute bottom-3 right-3 z-10 hidden sm:flex h-[min(152px,42vw)] w-[min(140px,38vw)] max-w-[153px] flex-col items-center justify-center rounded-[10px] border border-slate-100/90 bg-[#FAF9F6] px-2 py-3 text-center shadow-md sm:bottom-[-24px] sm:right-[-16px] sm:h-[177px] sm:w-[153px] sm:px-3 sm:py-4 lg:bottom-[-40px] lg:right-[-30px]"
            >
              <p className="mt-1 font-inter font-regular lg:text-[18px] text-[14px] sm:text-[16px] leading-snug text-[#2B2B2B] ">
              {aboutPreview?.badgeText}
              </p>
            </div>
            {/* Mobile years badge */}
            <div className="mt-4 flex sm:hidden h-[110px] w-[140px] flex-col items-center justify-center rounded-[10px] border border-slate-100/90 bg-[#FAF9F6] px-2 py-2 text-center shadow-md">
              <p className="mt-1 font-inter font-regular text-[12px] leading-snug text-[#2B2B2B]">
                {aboutPreview?.badgeText}
              </p>
            </div>
          </div>

          <div className="min-w-0 text-left font-dm lg:min-h-0">
            <div className="flex min-w-0 flex-col items-start lg:pt-4 xl:pt-8">
                <h2 className="text-[24px] md:text-[35px] font-Plus Jakarta Sans font-bold leading-tight text-[#1a1a3d] lg:text-[45px]">
                  {aboutPreview?.title}
                </h2>
                {aboutPreview?.subtitle ? (
                  <p className="mt-3 text-[18px] font-bold leading-snug text-[#2B2B2B] sm:text-[20px] md:text-[22px]">
                    {aboutPreview.subtitle}
                  </p>
                ) : null}
                <div className="mt-6 w-full max-w-xl space-y-4 text-[18px] leading-relaxed text-[#2B2B2B] font-inter font-regular">
                  {(aboutPreview?.paragraphs || [])
                    .filter(
                      (paragraph) =>
                        paragraph &&
                        paragraph.trim() !==
                          String(aboutPreview?.closingStatement || "").trim(),
                    )
                    .map((paragraph, index) => (
                      <p key={`about-p-${index}`}>{paragraph}</p>
                    ))}
                  {aboutPreview?.closingStatement ? (
                    <p className="font-bold text-[#1565D8]">
                      {aboutPreview.closingStatement}
                    </p>
                  ) : null}
                </div>
            </div>
          </div>
        </div>
      </div>

      {/* Impact Areas — white above arc; cream starts under the yellow stroke */}
      <div className="relative overflow-hidden bg-white">
        <div className="pointer-events-none relative w-full leading-[0]" aria-hidden>
          <svg
            className="block h-14 w-full sm:h-16 lg:h-[4.5rem]"
            viewBox="0 0 1440 90"
            fill="none"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Cream fill starts after (below) the arc */}
            <path
              d="M0 74C280 8 1160 8 1440 74L1440 90H0V74Z"
              fill="#FAF8F3"
            />
            <path
              d="M0 74C280 8 1160 8 1440 74"
              stroke="#F5C542"
              strokeWidth="9"
              strokeLinecap="round"
              vectorEffect="nonScalingStroke"
            />
          </svg>
        </div>

        <div className="relative bg-[#FAF8F3] pb-10 sm:pb-20">
        {/* Decorative vectors — full section width, cropped at edges (opacity is in each SVG path) */}
        <div
          className="impact-stats-vectors pointer-events-none absolute inset-x-0 bottom-0 z-[1] hidden h-[250px] md:block lg:h-[300px]"
          aria-hidden
        >
          <style>{`
            /* Left strokes — enter from left */
            .impact-stats-vectors .impact-v1 {
              width: 650px;
              height: 300px;
              left: -200px;
              bottom: 150px;
              transform: rotate(-24.43deg);
            
            }
            .impact-stats-vectors .impact-v2 {
              width: 700px;
              height: 350px;
              left: -200px;
              bottom: 150px;
              transform: rotate(-24.43deg);
              
            }
            .impact-stats-vectors .impact-v3 {
              width: 167px;
              height: 265px;
              right: -100px;
              bottom: -80px;
            }
            .impact-stats-vectors .impact-v4 {
              width: 172px;
              height: 273px;
              right: -70px;
              bottom: -60px;
            }
            @media (max-width: 1023px) {
              .impact-stats-vectors .impact-v1 {
                width: 520px;
                height: 92px;
                left: -165px;
                top: 40%;
              }
              .impact-stats-vectors .impact-v2 {
                width: 560px;
                height: 99px;
                left: -160px;
                top: calc(40% + 4px);
              }
              .impact-stats-vectors .impact-v3 { width: 140px; height: 222px; right: -82px; bottom: -66px; }
              .impact-stats-vectors .impact-v4 { width: 144px; height: 228px; right: -58px; bottom: -50px; }
            }
          `}</style>
          <img
            src={vector1}
            alt=""
            loading="lazy"
            className="impact-v1 absolute max-w-none select-none"
          />
          <img
            src={vector2}
            alt=""
            loading="lazy"
            className="impact-v2 absolute max-w-none select-none"
          />
          <img
            src={vector3}
            alt=""
            loading="lazy"
            className="impact-v3 absolute max-w-none select-none object-contain"
          />
          <img
            src={vector4}
            alt=""
            loading="lazy"
            className="impact-v4 absolute max-w-none select-none object-contain"
          />
        </div>

        <ImpactAreas data={impactAreas} />
        </div>
      </div>

      {/* Why Partner With ASSET — kept for future use
      <section className="relative px-4 py-10 sm:px-6 sm:py-16 lg:px-14 lg:py-20">

        <div
          className="absolute top-0 left-0 w-full h-[80%] bg-no-repeat bg-cover bg-center"
          style={{
            backgroundImage: `url(${vectorImage})`,
            zIndex: 0,
          }}
        ></div>

        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6 ">
            <h2 className="font-Plus Jakarta Sans text-[24px] md:text-[35px] py-5 sm:py-0 font-bold text-[#1a1a3d] lg:text-[45px] ">
              {partnership?.title || "Why Partner With ASSET"}
            </h2>
            <Link
              to={partnership?.ctaLink || "/contact-us"}
              className="inline-flex w-full shrink-0 items-center justify-center rounded-lg bg-[#1565D8] px-6 py-3 font-inter text-[16px] font-medium text-white shadow-sm transition sm:w-auto"
            >
              {partnership?.ctaText || "Partner With Us"}
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8 px-4 sm:px-8 lg:px-1">
            {partnerCards.map(({ image, title, description }) => (
              <article
                key={title}
                className="rounded-xl bg-[#FFFFFF] px-6 py-8 text-center shadow-lg sm:px-7 sm:py-9"
              >
                <img
                  src={image}
                  alt=""
                  loading="lazy"
                  className="mx-auto h-10 w-auto max-w-[3.5rem] object-contain sm:h-12 sm:max-w-[4rem] lg:h-14 lg:max-w-[4.5rem]"
                />
                <h3 className="mt-6 font-Plus Jakarta Sans text-[20px] font-bold leading-snug text-[#1a1a3d]">
                  {title}
                </h3>
                <p className="mt-3 font-inter font-regular text-[18px] leading-relaxed text-[#1a1a3d]/90">
                  {description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>
      */}



      <section
        className="relative z-[1] mt-0 min-h-[min(520px,100svh)] w-full overflow-hidden pb-16 pt-12 sm:min-h-[560px] sm:pb-20 sm:pt-16 md:min-h-[600px] md:pt-20 lg:pb-28 lg:pt-28"
        aria-labelledby="who-we-serve-heading"
        style={{ backgroundColor: "#8B5A2B" }}
      >
        {/* Design background — warm golden photograph */}
        <div
          className="pointer-events-none absolute inset-0 scale-105 bg-cover bg-[position:center_35%] bg-no-repeat"
          style={{ backgroundImage: `url(${whoWeServeBg})` }}
          aria-hidden
        />
        {/* Soft warm wash — keep photo golden/readable like design */}
        <div
          className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#8B5A2B]/20 via-[#8B5A2B]/15 to-[#8B5A2B]/25"
          aria-hidden
        />

        <div className="relative z-10 w-full pb-8 sm:pb-10">
          <div className="flex flex-col gap-5 px-4 sm:flex-row sm:items-start sm:justify-between sm:gap-8 sm:px-6 md:px-8 lg:px-16 xl:px-20">
            <h2
              id="who-we-serve-heading"
              className="max-w-3xl px-1 font-bold leading-[1.15] tracking-tight text-white drop-shadow-[0_2px_14px_rgba(0,0,0,0.35)] text-[26px] sm:max-w-2xl sm:px-0 sm:text-[32px] lg:max-w-3xl lg:text-[42px] lg:leading-[1.12]"
            >
              {whoWeServe.title ||
                "Who We Are Supporting Every Stage of the Engineering Journey"}
            </h2>

            <div className="relative z-20 flex w-full shrink-0 justify-end gap-3 sm:w-auto sm:justify-start sm:gap-3.5 sm:self-start sm:pt-1">
              <button
                type="button"
                aria-label="Previous slide"
                onClick={() => scrollWhoWeServe(-1)}
                className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#1a1a3d] shadow-[0_6px_18px_rgba(0,0,0,0.2)] transition hover:bg-white active:scale-95 sm:h-12 sm:w-12 lg:h-[52px] lg:w-[52px]"
              >
                <span className="sr-only">Previous slide</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
                  <path d="M15 18l-6-6 6-6" />
                </svg>
              </button>
              <button
                type="button"
                aria-label="Next slide"
                onClick={() => scrollWhoWeServe(1)}
                className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#1a1a3d] shadow-[0_6px_18px_rgba(0,0,0,0.2)] transition hover:bg-white active:scale-95 sm:h-12 sm:w-12 lg:h-[52px] lg:w-[52px]"
              >
                <span className="sr-only">Next slide</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </button>
            </div>
          </div>

          <div className="min-w-0 lg:pl-10 xl:pl-16">
            <div
              ref={whoWeServeScrollRef}
              className="mt-6 grid w-full min-w-0 grid-flow-col snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth px-4 pb-2 sm:mt-10 sm:gap-5 sm:px-6 sm:pt-6 md:gap-6 md:px-8 lg:mt-10 lg:gap-7 lg:px-10 lg:pt-8 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] after:w-[1px] after:content-['']"
            >
              {whoWeServeSlides.map(({ image, title, alt, description }, index) => (
                <article
                  key={`${title}-${index}`}
                  data-serve-card
                  className="w-[calc(100vw-2.5rem)] max-w-[20rem] shrink-0 snap-start sm:w-[min(280px,calc(100vw-3.5rem))] sm:max-w-none md:w-[260px] lg:w-[270px]"
                >
                  <div className="flex h-[min(72vw,390px)] flex-col overflow-hidden rounded-[18px] bg-white shadow-[0_12px_28px_rgba(0,0,0,0.22)] sm:h-[370px] lg:h-[380px]">
                    <div className="relative h-[56%] w-full shrink-0 overflow-hidden rounded-t-[18px]">
                      <img
                        src={image}
                        alt={alt || title}
                        loading="lazy"
                        className="h-full w-full object-cover"
                      />
                      <img
                        src={whoWeServeArrow}
                        alt=""
                        width={100}
                        height={97}
                        loading="lazy"
                        className="pointer-events-none absolute right-0 top-0 z-10 h-auto w-[min(38%,5.25rem)] sm:w-[min(36%,5.5rem)] lg:w-[5.5rem]"
                        aria-hidden
                      />
                    </div>

                    <div className="flex flex-1 flex-col items-center justify-center bg-white px-4 py-5 text-center sm:px-5 sm:py-6">
                      <h3 className="text-[16px] font-bold leading-snug text-[#1a1a1a] sm:text-[17px] lg:text-[18px]"> 
                        {title}
                      </h3>
                      {(description || alt) ? (
                        <p className="mt-2 max-w-[16rem] text-[13px] leading-relaxed text-[#4b5563] sm:text-[14px]">
                          {description || alt}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div> 

        {/* Transition divider — yellow curve over the full background image */}
        <div className="pointer-events-none absolute inset-x-0 bottom-0 z-20 w-full leading-[0]" aria-hidden>
          <svg
            className="block h-14 w-full sm:h-16 lg:h-20"
            viewBox="0 0 1440 100"
            fill="none"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ display: "block" }}
          >
            {/* Cream area below the arc matching ProgramsOverview */}
            <path
              d="M0 82C340 14 1100 14 1440 82V100H0V82Z"
              fill="#FAF8F3"
            />
            {/* Yellow arc */}
            <path
              d="M0 82C340 14 1100 14 1440 82"
              stroke="#F5C542"
              strokeWidth="8"
              strokeLinecap="round"
              vectorEffect="nonScalingStroke"
            />
          </svg>
        </div>
      </section>

      <ProgramsOverview data={programsOverview} />
      <IndustryPartnerships data={industryPartnerships} />
      <JoinMovement data={joinMovement} />

      <div className="relative z-10 mx-auto mt-8 w-full max-w-[min(100%,1440px)] px-3 sm:mt-10 sm:px-4 lg:px-5 -mb-20 sm:-mb-24 lg:-mb-20 lg:w-[1100px]">
        <div
          className="relative mx-auto flex w-full max-w-full flex-col items-center justify-center gap-5 overflow-hidden rounded-lg px-10 text-center shadow-[0_10px_28px_-8px_rgba(15,23,42,0.18)] sm:gap-6 sm:rounded-2xl sm:px-6 sm:py-8 md:max-w-4xl md:gap-6 md:px-8 md:py-9 lg:max-w-5xl lg:flex-row lg:items-center lg:justify-between lg:gap-6 lg:py-20 xl:max-w-6xl xl:gap-8"
          style={{ backgroundColor: '#FFC947' }}
        >
          <img
            src={shapes}
            alt=""
            loading="lazy"
            className="pointer-events-none absolute 
                 top-[-10px] left-[-13%] w-[100%]
                 lg:top-[-30px] lg:left-[-20%] lg:w-[120%] opacity-60 scale-x-[-1]"
          />

          <p className="relative z-10 w-full text-center font-bold leading-snug text-black sm:text-xl md:text-[26px] lg:min-w-0 lg:flex-1 lg:max-w-7xl lg:pr-3 lg:text-left lg:text-[32px] mt-4 md:mt-0 lg:mt-0">
            {joinUs.title ||
              "Join the movement and help shape the future of engineering."}
          </p>

          <form
            className="relative z-10 flex w-full max-w-full flex-col gap-2
                 sm:max-w-md sm:mx-auto
                 md:max-w-md
                 lg:max-w-[410px] mb-4 md:mb-0 lg:mb-0"
            onSubmit={handleJoinUsSubmit}
          >
            <div
              className="flex w-full flex-row items-center gap-2 rounded-lg bg-white p-1.5 shadow-sm
                   sm:flex-row sm:items-stretch sm:gap-1 sm:rounded-md sm:p-1.5 sm:pl-3
                   md:pl-4"
            >
              <input
                type="email"
                name="email"
                value={joinEmail}
                onChange={(ev) => setJoinEmail(ev.target.value)}
                placeholder={joinUs?.placeholder || "Type your email here, we'll Contact You!"}
                required
                maxLength={255}
                pattern={JOIN_US_EMAIL_REGEX.source}
                title="Enter a valid email, e.g. name@example.com"
                autoComplete="email"
                disabled={joinSubmitting}
                className="flex-1 min-w-0 px-2 py-1.5 text-[12px] outline-none text-left
                sm:min-h-[44px] sm:px-3 sm:py-2.5 sm:text-[16px]
                disabled:opacity-60" />
              <button
                type="submit"
                disabled={joinSubmitting}
                className="whitespace-nowrap cursor-pointer rounded-md bg-[#1565D8] px-3 py-1.5 text-[12px] text-white
                     sm:px-5 sm:py-2.5 sm:text-[16px]
                     disabled:opacity-60">
                {joinSubmitting
                  ? "Sending…"
                  : `${joinUs.buttonText || "Send"} →`}
              </button>
            </div>
            {joinMessage ? (
              <p className="w-full text-center text-sm font-medium text-neutral-900 sm:text-left">
                {joinMessage}
              </p>
            ) : null}
            {joinError ? (
              <p
                className="w-full text-center text-sm font-medium text-red-700 sm:text-left"
                role="alert"
              >
                {joinError}
              </p>
            ) : null}
          </form>
        </div>
      </div>

    </>
  );
}

export default Hero;
